import gql from "graphql-tag"
import {ExternalBusinessMetadata} from "@irati/tenant-metadata/services/query/fragments"
import UserOnboarding from "@irati/onboarding/services/fragments/userOnboarding"
import fullUserV4 from "@irati/identity/services/fragments/fullUserV4"
import fullBusiness from "@irati/identity/services/fragments/fullBusiness"
import fullTenant from "@irati/identity/services/fragments/FullTenant"
import fullBranding from "@irati/brand/services/fragments/fullBranding"
import productPermissions from "../fragments/productPermissions"

const query = gql`
  query ResumeSessionV4($userId: ID!, $businessId: ID!, $tenantId: String!) {
    user(id: $userId) {
      ...fullUser
    }
    branding(businessId: $businessId) {
      ...fullBranding
    }
    productPermissions {
      ...fullProductPermissions
    }
    userTenant: tenant(tenantId: $tenantId) {
      ...fullTenant
    }
    business(businessId: $businessId) {
      ...fullBusiness
    }
    userOnboarding(userId: $userId) {
      ...UserOnboarding
    }
    businessMetadata(businessId: $businessId) {
      ...externalBusinessMetadata
    }
    dealPackage {
      uuid
      name
      locale
      region
      termsAndConditionsUrl
      addons {
        uuid
        name
      }
    }
    userTeamAssignments(id: $userId) {
      teamId
      assignment
    }
  }
  ${fullUserV4}
  ${fullTenant}
  ${fullBranding}
  ${fullBusiness}
  ${productPermissions}
  ${UserOnboarding}
  ${ExternalBusinessMetadata}
`

export const toString = query.loc.source.body

export default query
